import { OigStatusChip } from '../../../../ui/features/shift-details/components/OigStatusChip';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Chip, Divider, FormControl, FormHelperText, InputLabel, List, ListItem, Stack, Typography } from '@mui/material';
import React from 'react';
import { PositionSelect } from '../components/PositionSelect';
import { useReviewParticipationsContext } from '../contexts/ReviewParticipationsContext';
const labelId = 'position-select-label';
export const useReviewParticipantsTableColumns = ({ onDenyParticipation }) => {
    const { t } = useMissionsTranslation();
    const { updateSelectedPositions, selectedPositions, showErrors } = useReviewParticipationsContext();
    const columns = [
        {
            cellFunction: (row) => {
                return (React.createElement(Stack, { gap: 0 },
                    React.createElement(Typography, { variant: 'subtitle1' }, row.columns.participantFullName),
                    React.createElement(List, null, row.columns.occupations.map((occupation) => (React.createElement(ListItem, { sx: { p: 0 }, dense: true, key: occupation },
                        React.createElement(Typography, { variant: 'body2' }, occupation))))),
                    React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, row.columns.countyTribe)));
            },
        },
        {
            cellFunction: (row) => {
                return (React.createElement(Stack, { direction: 'row', gap: 1 },
                    React.createElement(ParticipationStatusChip, { participationStatus: row.columns.status }),
                    React.createElement(OigStatusChip, { oigStatus: row.columns.accountOigStatus })));
            },
        },
        {
            cellFunction: (row) => {
                var _a;
                const handleSelectPosition = (positionId) => {
                    updateSelectedPositions(row.id, positionId);
                };
                return (React.createElement(Box, { display: 'flex', justifyContent: 'end' }, row.columns.positions.length > 1 ? (React.createElement(FormControl, { error: showErrors && !selectedPositions[row.id] },
                    React.createElement(InputLabel, { id: `${labelId}-${row.id}` }, "Select position"),
                    React.createElement(PositionSelect, { positions: row.columns.positions, onSelectPosition: handleSelectPosition, selectedPosition: (_a = selectedPositions[row.id]) !== null && _a !== void 0 ? _a : '', label: t('shifts.pendingRequest.review.positions.select'), labelId: `${labelId}-${row.id}` }),
                    showErrors && !selectedPositions[row.id] && (React.createElement(FormHelperText, null, t('shifts.pendingRequest.review.positions.required'))))) : (React.createElement(Typography, { variant: 'body2' }, row.columns.positions[0].positionName))));
            },
        },
        {
            cellFunction: (row) => {
                const handleDenyVolunteer = (e) => {
                    e.stopPropagation();
                    onDenyParticipation(row);
                };
                return (React.createElement(Stack, { justifyContent: 'right', gap: 2, direction: 'row', alignItems: 'center' },
                    React.createElement(Divider, { orientation: 'vertical', flexItem: true }),
                    React.createElement(Button, { onClick: handleDenyVolunteer, startIcon: React.createElement(CloseIcon, null), endIcon: React.createElement(ChevronRightIcon, null) }, t('common.deny'))));
            },
        },
    ];
    return { columns };
};
const ParticipationStatusChip = ({ participationStatus }) => {
    const { t } = useMissionsTranslation();
    switch (participationStatus) {
        case 'deniedNotQualified':
        case 'deniedRosterFull':
            return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center' } },
                React.createElement(Chip, { sx: { backgroundColor: themeColors.accent.grey.subtlest, color: themeColors.accent.grey.bold }, "data-test": 'participation-status-chip', label: t('shifts.pendingRequest.review.participationStatus.denied'), size: 'small', variant: 'filled' })));
        default:
            return null;
    }
};
